module.exports = __webpack_public_path__ + "img/domains-step-3.en.3d015dfd.png";